import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import SharedConstants from 'common/constants/SharedConstants';

const AppUpdate = ({ appUpdateContents }) => {
  if (!appUpdateContents || appUpdateContents.length === 0) {
    return <></>;
  }
  return (
    <div className='app-update align-items-center d-flex flex-column'>
      {appUpdateContents.map(
        (item, idx) =>
          (SharedConstants.CMS_CONTENT_TYPES.LOGO_ICON === item.contentType && (
            <div key={idx} className={`d-flex p-2 ${item.className}`}>
              <img src={item.imgSrc} alt={item.altTxt} />
            </div>
          )) ||
          (SharedConstants.CMS_CONTENT_TYPES.MULTI_TEXT === item.contentType && (
            <div key={idx} className='update-txt text-uppercase'>
              {item.txts.map((txt, idx) => {
                return <span key={idx}>{txt}</span>;
              })}
            </div>
          )) ||
          (SharedConstants.CMS_CONTENT_TYPES.CALL_TO_ACTION === item.contentType && (
            <div key={idx} className='p-2 mt-2'>
              <ButtonComp
                className='button blackButton text-uppercase'
                aria-label='app-update-button'
                onClickHandler={item.onClickHandler}
                id='appUpdateButton'
                type='submit'
                data-testid='app-update-button'
              >
                <span>{item.txt}</span>
              </ButtonComp>
            </div>
          )),
      )}
    </div>
  );
};

export default AppUpdate;
